import { ReactNode, useEffect, useRef, useState } from "react";
import { prefersReducedMotion } from "@/cinematic/config";

/**
 * Revela a seção como um eco de sonar: fade + leve deslocamento e um
 * anel concêntrico sutil que se expande e dissolve. Com
 * prefers-reduced-motion, o conteúdo aparece sem animação.
 */
const RevealSection = ({ children }: { children: ReactNode }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(() => prefersReducedMotion());

  useEffect(() => {
    if (inView) return;
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          io.disconnect();
        }
      },
      { rootMargin: "0px 0px -10% 0px", threshold: 0.05 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [inView]);

  return (
    <div
      ref={ref}
      className={`echo-reveal rounded-3xl transition-all duration-1000 ease-out will-change-transform ${
        inView ? "echo-active translate-y-0 opacity-100" : "translate-y-12 opacity-0"
      }`}
    >
      {children}
    </div>
  );
};

export default RevealSection;
